<template>
    <div>
        <section id="single-page-header">
            <div class="overlay">
                <div class="new-header-container">
                <div class="row">
                    <div class="col-md-6 col-sm-6 col-xs-12">
                    <div class="single-page-header-left">
                        <h2> Փաթեթներ </h2>
                    </div>
                    </div>
                    <div class="col-md-6 col-sm-6 col-xs-12">
                    <div class="single-page-header-right">
                        <ol class="breadcrumb float-right">
                        <li class="breadcrumb-item">
                            <router-link to="/" class="open_review">
                                {{ $t('menu.home') }}
                            </router-link>
                        </li>
                        <li class="breadcrumb-item active"> Փաթեթներ </li>
                        </ol>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </section>
        <div class="new-container table-sp" v-if="$route.params.type === 'private'">
            <table class="price-table">
                <thead>
                    <tr>
                        <th class="border-left-0 border-bottom-0 border-top-0"></th>
                        <th class="text-center">Անվճար փաթեթ</th>
                        <th class="text-center">Էկոնոմ փաթեթ</th>
                        <th class="text-center">Պրեմիում փաթեթ</th>
                        <th class="text-center">Գոլդ փաթեթ</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="details">Համակարգի միջոցով տենդերներ կազմակերպելու և մասնակցելու հնարավորություն</td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="details">Տարբեր տեսակի ֆիլտրներից օգտվելու հնարավորություն</td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="details">ՀՀ-ում տեղի ունեցող տենդերների քանակական վիճակագրությունից օգտվելու հնարավորություն</td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="details">Պետական մեկ անձից գնման գործընթացներին համակարգի միջոցով գնային առաջարկ ներկայացնելու հնարավորություն</td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="details">Արտոնյալ պայմաններով տենդերների բանկային երաշխիքների տրամադրում ՎՏԲ-Հայաստան Բանկի կողմից /գործող համագործակցության շրջանակներում/</td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="details">iTender հարթակում որպես գործընկեր ներկայացնելու հնարավորություն</td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="details">Տենդերների հրավերների ստացում /պետական և մասնավոր/</td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="details">Պետական գնման գործընթացների ընթացքին հետևելու և ավարտված տենդերների մասնակիցներին, ներկայացված գներին, հաղթողներին տեսնելու հնարավորություն</td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="details">Պետական մրցույթներին համակարգի միջոցով մասնակցության հայտերի, որակավորման և պայմանագրի ապահովումների ԱՆՍԱՀՄԱՆԱՓԱԿ պատրաստում</td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="details">Հաղթած տենդերների պահեստի ձևավորում, կառավարում, ընդունման -հանձնման արձանագրությունների և ակտերի ԱՆՍԱՀՄԱՆԱՓԱԿ պատրաստում</td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="details">Պետական գնումների մասնակցության ուղեցույցի հասանելիություն</td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="details">Գնումների մասին օրենսդրական փոփոխությունների վերաբերյալ ծանուցում</td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="details">Նախահաշվային գնի տրամադրում հրապարակված լինելու դեպքում</td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="border-0"></td>
                        <td class="position-relative px-2 border-bottom-0 w-300"  v-for="(item, itemIndex) in packageBlockContent" :key="item" >
                            <div v-if="isAuthenticated === true && me.package === 'Անվճար'">
                                <button :disabled="!item.cash" @click="()=>{$modal.show('payment-modal', {packageId, selectedPrice});isLoaded=false;}" class="d-flex justify-content-between pay-btn align-items-center cursor" v-if="item.packageHeader !== undefined" :class="{'d-flex' : item.changeBoolean}" >
                                    <p>{{ item.cash }}</p>
                                    <p class="ml-2">վճարել</p>
                                </button>
                            </div>
                            <div v-else-if="isAuthenticated === true && me.package !== 'Անվճար'">
                                <button :disabled="!item.cash" @click="withActivatePackage" class="d-flex justify-content-between pay-btn align-items-center cursor" v-if="item.packageHeader !== undefined" :class="{'d-flex' : item.changeBoolean}" >
                                    <p>{{ item.cash }}</p>
                                    <p class="ml-2">վճարել</p>
                                </button>
                            </div>
                            <div v-else>
                                <button @click="buyPackage" class="d-flex justify-content-between pay-btn align-items-center cursor" v-if="item.packageHeader !== undefined" :class="{'d-flex' : item.changeBoolean}" >
                                    <p>{{ item.cash }}</p>
                                    <p class="ml-2">վճարել</p>
                                </button>
                            </div>
                            <div class="package-sum-block" v-if="item.sumAndMonth !== undefined " :class="{'d-block' : item.changeBoolean}">
                                <div v-for="(k, index) in item.sumAndMonth" :key="index" class="d-flex align-items-center pb-4">
                                    <input type="radio" class="blue-circle cursor" name="price" @click="() => getSum(k, item, pricings[itemIndex])">
                                    <p class="sum-text mb-0 "><span>{{ k[2] }} ամիս՝</span> {{Math.round(pricings[itemIndex].price[`price_${k[2]}`].price / pricings[itemIndex].price[`price_${k[2]}`].month)}} դր/ամիս</p>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="new-container table-sp" v-else-if="$route.params.type === 'state'">
            <table class="state-price-table">
                <thead>
                    <tr>
                        <th class="border-left-0 border-bottom-0 border-top-0"></th>
                        <th class="text-center">Էկոնոմ փաթեթ</th>
                        <th class="text-center">Պրեմիում փաթեթ</th>
                        <th class="text-center">Գոլդ փաթեթ</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td class="details">
                            <p class="info">Գնումների պլանի ստեղծում և կառավարում</p>
                            <p class="more cursor" @click="more(1)">ավելին՝</p>
                            <ul ref="containerSize_1">
                                <li class="hidden" :class="{ 'show' : showMore_id_1}">մեկից ավելի տեսակների (պետական բյուջեի կամ այլ միջոցների հաշվին իրականացվող) և տարբեր տարիների գնումների պլանի ստեղծման հնարավորություն</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_1}">գնումների պլանի անսահմանափակ փոփոխությունների իրականացման հնարավորություն</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_1}">գնումների պլանի արտահանում excel և pdf ձևաչափերով</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_1}">գնման առարկաների ավելացում ԳՄԱ (CPV) կոդերի հայերեն և ռուսերեն անվանումների նույնականացմամբ</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_1}">գնումների պլանում գնման առարկաների ավտոմատ դասակարգում` ըստ խմբերի և հերթականության</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_1}">գնման ձևերի ավտոմատ որոշման հնարավորություն</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_1}">գնումների պլանավորում` ըստ ծրագրերի և ծախսային հոդվածների դասակարգման</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_1}">պլանավորված և փաստացի իրականացված գնումների վերահսկողություն</li>
                            </ul>
                        </td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="details">
                            <p class="info">Պատասխանատու ստորաբաժանումների ստեղծում </p>
                            <p class="more cursor" @click="more(2)">ավելին՝</p>
                            <ul ref="containerSize_2">
                                <li class="hidden" :class="{ 'show' : showMore_id_2}">մեկից ավելի պատասխանատու ստորաբաժանումների ստեղծում </li>
                                <li class="hidden" :class="{ 'show' : showMore_id_2}">hրամանի պատրաստում ավտոմատ եղանակով</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_2}">պատասխանատու ստորաբաժանումների համար համակարգում «անձնական սենյակի» տրամադրում <span class="color"> (շուտով)</span> </li>
                                <li class="hidden" :class="{ 'show' : showMore_id_2}">պատասխանատու ստորաբաժանումների կողմից գնման հայտերի պատրաստման, ներկայացման համար անհրաժեշտ գործիքակազմի ապահովում <span class="color"> (շուտով)</span></li>
                                <li class="hidden" :class="{ 'show' : showMore_id_2}">պայմանագրերի կառավարման համար անհրաժեշտ գործիքակազմի ապահովում («Գոլդ» փաթեթի շրջանակում)</li>
                            </ul>
                        </td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="details">
                            <p class="info">Մեկ անձից գնման ընթացակարգերի կազմակերպում </p>
                            <p class="more cursor" @click="more(3)">ավելին՝</p>
                            <ul ref="containerSize_3">
                                <li class="hidden" :class="{ 'show' : showMore_id_3}">գնման ընթացակարգի կազմակերպում գնումների պլանից ընտրված ելակետային տվյալների հիման վրա</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_3}">գնման ընթացակարգի կազմակերպում դրսից մուտքագրված ելակետային տվյալների հիման վրա</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_3}">ընթացակարգի կազմակերպում մեկ կամ ավելի մասնակիցների ներգրավմամբ</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_3}">ընթացակարգի կազմակերպման հնարավորություն համակարգում ներդրված մրցակցային հարթակի միջոցով</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_3}">ընտրված մասնակցի որոշում ըստ առանձին չափաբաժինների կամ ըստ ընդհանուր գների հանրագումարի</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_3}">մուտքագրված ելակետային տվյալների հիման վրա գնումների մասին ՀՀ օրենսդրությամբ նախատեսված բոլոր փաստաթղթերի ավտոմատ պատրաստում word և pdf ձևաչափերով (խմբագրման հնարավորությամբ), ընդ որում՝
                                    <ul class="child-list">
                                        <li class="hidden" :class="{ 'show' : showMore_id_3}">գնման հայտ (հայերեն)</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_3}">պատասխանատու ստորաբաժանման հրաման  (հայերեն)</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_3}">մասնակիցներին ներկայացվող պայմաններ (պայմանագրի նախագիծ) (հայերեն)</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_3}">հայտերի գնահատման նիստի արձանագրություն (հայերեն)</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_3}">մասնակցի կողմից ներկայացվող գնային առաջարկ (հայերեն)</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_3}">վերջնական պայմանագիր (հայերեն)</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_3}">պայմանագիր կնքելու որոշման մասին հայտարարություն (հայերեն և ռուսերեն)</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_3}">չկայացած ընթացակարգի (չափաբաժինների) մասին հայտարարություն(հայերեն և ռուսերեն)</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_3}">կնքված պայմանագրի մասին հայտարարություն (հայերեն և ռուսերեն)</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_3}">գնման ընթացակարգի արձանագրություն (գնման գինը 1մլն գերազանցելու դեպքում)(հայերեն)</li>
                                    </ul>
                                </li>
                            </ul>
                        </td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="details">
                            <p class="info">Մրցակցային գնման ընթացակարգերի (ԲՄ,  ՀԲՄ, ԳՀ, ՀՄԱ) կազմակերպում </p>
                            <p class="more cursor" @click="more(4)">ավելին՝</p>
                            <ul ref="containerSize_4">
                                <li class="hidden" :class="{ 'show' : showMore_id_4}">գնման ընթացակարգի կազմակերպում գնումների պլանից ընտրված ելակետային տվյալների հիման վրա</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_4}">գնման ընթացակարգի կազմակերպում դրսից մուտքագրված ելակետային տվյալների հիման վրա</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_4}">գների ավտոմատ համեմատում և ընտրված մասնակցի որոշում</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_4}">գնումների գործընթացին մասնակցելու իրավունք չունեցող մասնակիցների ցուցակում մասնակցի առկայության վերաբերյալ ավտոմատ ծանուցում մուտքագրման ընթացքում</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_4}">էլեկտրոնային գնումների դեպքում մասնակցի կողմից ներկայացված հայտերի (zip ֆայլեր) ներբեռնման և գների ավտոմատ լրացման հնարավորություն՝ ըստ համապատասխան չափաբաժինների</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_4}">բանակցությունների ընթացքում մասնակիցների կողմից ներկայացված նոր գնային առաջարկների մուտքագրման հնարավորություն</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_4}">մուտքագրված ելակետային տվյալների հիման վրա գնումների մասին ՀՀ օրենսդրությամբ նախատեսված բոլոր փաստաթղթերի ավտոմատ պատրաստում word և pdf ձևաչափերով (խմբագրման հնարավորությամբ), ընդ որում՝
                                    <ul class="child-list">
                                        <li class="hidden" :class="{ 'show' : showMore_id_4}">գնման հայտ (հայերեն) <span class="color"> (շուտով)</span></li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_4}">պատասխանատու ստորաբաժանման հրաման  (հայերեն)</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_4}">գնահատող հանձնաժողովի հրաման</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_4}">գնահատող հանձնաժողովի առաջին նիստի արձանագրություն</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_4}">պայմանագրի նախագիծ (հայերեն և ռուսերեն)</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_4}">ընթացակարգի հայտարարություն և հրավեր (էլեկտրոնային և թղթային տարբերակներով ապրանք, ծառայություն, աշխատանք)(հայերեն և ռուսերեն)<span class="color"> (շուտով)</span></li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_4}">հայտերի բացման և գնահատման նիստի արձանագրություն (հայերեն և ռուսերեն)</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_4}">շահերի բախման բացակայության մասին հայտարարություն (հայերեն)</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_4}">գնահատման թերթիկ (հայերեն)</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_4}">ծանուցումներ (բանակցություններ, ՊԵԿ և այլ)(հայերեն)</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_4}">պայմանագիր կնքելու որոշման մասին հայտարարություն (հայերեն և ռուսերեն)</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_4}">չկայացած ընթացակարգի (չափաբաժինների) մասին հայտարարություն(հայերեն և ռուսերեն)</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_4}">պայմանագիր կնքելու առաջարկ</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_4}">վերջնական պայմանագիր (հայերեն)</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_4}">համաձայնագրեր <span class="color"> (շուտով)</span></li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_4}">կնքված պայմանագրի մասին հայտարարություն (հայերեն և ռուսերեն)</li>
                                        <li class="hidden" :class="{ 'show' : showMore_id_4}">գնման ընթացակարգի արձանագրություն (գնման գինը 1մլն գերազանցելու դեպքում)(հայերեն)</li>
                                    </ul>
                                </li>
                            </ul>
                        </td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="details">
                            <p class="info">Պայմանագրի կառավարում</p>
                            <p class="more cursor " @click="more(6)">ավելին՝</p> 
                            <ul ref="containerSize_6">
                                <li class="hidden" :class="{ 'show' : showMore_id_6}">պայմանագրի շարժի վերահսկում</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_6}">հանձնման-ընդունման փաստաթղթերի՝ ներառյալ եզրակացության ավտոմատ կազմում հերթական համարակալմամբ</li>
                                <li class="hidden" :class="{ 'show' : showMore_id_6}">կատարման ժամկետների հիշեցում</li>
                            </ul>
                        </td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="details"> 
                            <p class="info">Գնման առարկայի տեխնիկական բնութագերի բազայից օգտվելու հնարավորություն <span class="color"> (շուտով)</span></p>
                            <p class="more cursor" @click="more(5)">ավելին՝</p> 
                            <ul ref="containerSize_5"> 
                                <li class="hidden" :class="{ 'show' : showMore_id_5}">հասանելիություն համակարգում մուտքագրված և/կամ վերամշակված բոլոր տեխնիկական բնութագրերին </li>
                                <li class="hidden" :class="{ 'show' : showMore_id_5}">տեխնիկական բնութագրերի հայերեն մուտքագրման ընթացքում տեքսի ավտոմատ թարգմանություն ռուսերենի (համակարգում ներդրված թարգմանչական գործիքակազմի միջոցով) </li>
                            </ul>
                        </td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center minus"><i class="fas fa-times"></i></td>
                        <td class="text-center plus"><i class="fas fa-check"></i></td>
                    </tr>
                    <tr>
                        <td class="border-0"></td>
                        <td class="position-relative px-2 border-bottom-0 w-300"  v-for="(item, itemIndex) in packageBlockContentForState" :key="itemIndex" >
                            <h2 class="text-dark text-center mb-5">{{'Ընդամենը՝' + ' ' + item.sum + ' ' + 'դրամ'}}</h2>
                            <div v-if="isAuthenticated === true">
                                <button @click="()=>{$modal.show('payment-state-modal', item.id );isLoaded=false;}" class="d-flex justify-content-between pay-btn align-items-center cursor text-white">
                                ՎՃԱՐԵԼ
                                </button>
                            </div>
                            <div v-else>
                                <button @click="buyPackage" class="d-flex justify-content-between pay-btn align-items-center cursor text-white">
                                ՎՃԱՐԵԼ
                                </button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <h4 v-if="$route.params.type === 'state'" style="color: #1c1c1c;" class="new-container my-4 ml-5 font-weight-bold">Ծառայությունների արժեքները սահմանված են 1 տարի ժամկետով և 1 համակարգողի համար։</h4>
        <payment-modal/>
        <payment-state-modal/>
    </div>
</template>

<script>
    import PaymentStateModal from '../../private/participant/tenders/modals/PaymentStateModal'
    import PaymentModal from '../../private/participant/tenders/modals/PaymentModal'
    export default {
        async mounted() {
            this.$store.dispatch('pricing/get').then(data => {
                this.packageBlockContent[1].packageText = 'Սկսած ' + Math.round( parseInt(this.pricings[1].price.price_12.price) / 12) + ' դրամից'
                this.packageBlockContent[2].packageText = 'Սկսած ' + Math.round( parseInt(this.pricings[2].price.price_12.price) / 12) + ' դրամից'
                this.packageBlockContent[3].packageText = 'Սկսած ' + Math.round( parseInt(this.pricings[3].price.price_12.price) / 12) + ' դրամից'
            })
            await this.$client.get('package/state').then(response => {
                this.statePrices = response.data
            })

            for(var index = 0; index < this.packageBlockContentForState.length; index++){
                this.packageBlockContentForState[index].sum = this.statePrices[index].price
                this.packageBlockContentForState[index].id = this.statePrices[index].id
            }

            this.$refs.containerSize_1.classList.add('h-0')
            this.$refs.containerSize_2.classList.add('h-0')
            this.$refs.containerSize_3.classList.add('h-0')
            this.$refs.containerSize_4.classList.add('h-0')
            this.$refs.containerSize_5.classList.add('h-0')
            this.$refs.containerSize_6.classList.add('h-0')
        },
        computed:{
            pricings() {
                return this.$store.getters['pricing/pricing']
            },
            userType(){
                return this.$store.getters.userType
            },
            isAuthenticated() {
                return this.$store.getters.isAuthenticated
            },
            me() {
                return this.$store.getters['user/me']
            },
        },
        methods: {
            consoleLog(data){
                console.log(data)
            },
            more(id){
                if(id === 1){
                    this.showMore_id_1 = !this.showMore_id_1;
                    if(!this.showMore_id_1){
                        setTimeout(() => {
                            this.$refs.containerSize_1.classList.add('h-0')
                        }, 600);
                    }else{
                        this.$refs.containerSize_1.classList.remove('h-0')
                    } 
                }                
                if(id === 2){
                    this.showMore_id_2 = !this.showMore_id_2;
                    if(!this.showMore_id_2){
                        setTimeout(() => {
                            this.$refs.containerSize_2.classList.add('h-0')
                        }, 600);
                    }else{
                        this.$refs.containerSize_2.classList.remove('h-0')
                    }
                }
                if(id === 3){
                    this.showMore_id_3 = !this.showMore_id_3;
                    if(!this.showMore_id_3){
                        setTimeout(() => {
                            this.$refs.containerSize_3.classList.add('h-0')
                        }, 600);
                    }else{
                        this.$refs.containerSize_3.classList.remove('h-0')
                    }
                }
                if(id === 4){
                    this.showMore_id_4 = !this.showMore_id_4;
                    if(!this.showMore_id_4){
                        setTimeout(() => {
                            this.$refs.containerSize_4.classList.add('h-0')
                        }, 600);
                    }else{
                        this.$refs.containerSize_4.classList.remove('h-0')
                    }
                }
                if(id === 5){
                    this.showMore_id_5 = !this.showMore_id_5;
                    if(!this.showMore_id_5){
                        setTimeout(() => {
                            this.$refs.containerSize_5.classList.add('h-0')
                        }, 600);
                    }else{
                        this.$refs.containerSize_5.classList.remove('h-0')
                    }
                }
                if(id === 6){
                    this.showMore_id_6 = !this.showMore_id_6;
                    if(!this.showMore_id_6){
                        setTimeout(() => {
                            this.$refs.containerSize_6.classList.add('h-0')
                        }, 600);
                    }else{
                        this.$refs.containerSize_6.classList.remove('h-0')
                    }
                }
            },
            viewPrices(item){
                if(item.packageHeader !== 'Անվճար փաթեթ'){
                    const element = this.packageBlockContent.find(i => i.id === item.id)
                    element.changeBoolean = true
                    this.changeStyles = true
                }else if(item.packageHeader === 'Անվճար փաթեթ'){
                    if(this.isAuthenticated === false){
                        this.$fire({
                            text: "Խնդրում ենք մուտք գործել համակարգ փաթեթը ակտիվացնելու համար",
                            type: "info",
                            confirmButtonText: 'Մուտք գործել',
                        }).then((result) => {
                            if (result.value) {
                                this.$router.push(`/login`);
                            } else {
                            }
                        })
                    }
                }
            },
            getSum(k, item, selectedPackage){
                console.log(selectedPackage.price[`price_${k[2]}`].month)
                this.packageId = selectedPackage.id;
                this.selectedPrice = selectedPackage.price[`price_${k[2]}`].month;
                const element = this.packageBlockContent.find(i => i.id === item.id)
                const otherElements = this.packageBlockContent.filter(i => i.id !== item.id)
                otherElements.forEach(otherElement => {
                    otherElement.cash = null
                });
                element.cash = k[1].slice(0, -5)
            },
            buyPackage(){
                if(this.isAuthenticated === true){
                    const requestData ={
                        package_id: this.packageId,
                        month:  this.selectedPrice,
                        method: 'arca'
                    }
                    this.$client.post('create/order/payment/url', requestData).then(({data}) => {
                        const { formUrl } = data
                        if(formUrl === undefined){
                            this.$router.push('/packages')
                        }else{
                            window.location.href = formUrl
                        }
                    })
                }else{
                    this.$fire({
                        text: "Խնդրում ենք մուտք գործել համակարգ փաթեթ գնելու համար",
                        type: "info",
                        confirmButtonText: 'Մուտք գործել',
                    }).then((result) => {
                        if (result.value) {
                            this.$router.push(`/login`);
                        } else {
                        }
                    })
                }
            },
            withActivatePackage(){
                this.$notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Դուք ունեք ակտիվ փաթեթ',
                    text: 'Հավելյալ հարցերի համար զանգահարել +37491244970'
                })
            },
        },
        data() {
        return {
            checkTime: false,
            showMore_id_1: false,
            showMore_id_2: false,
            showMore_id_3: false,
            showMore_id_4: false,
            showMore_id_5: false,
            showMore_id_6: false,
            statePrices: null,
            selectedPrice: 3,
            packageBlockContent: [
                {},
                {
                    packageHeader: 'Էկոնոմ փաթեթ',
                    packageText: '',
                    packageContent: 'Տենդերների տեղեկատվություն` տենդերներ /պետական, մասնավոր/, մրցակիցներ, հաղթող գներ...',
                    buttonContent: 'Գնել',
                    changeBoolean: false,
                    sumAndMonth: [ ['12 ամիս՝ ', `49 000 դրամ/ամիս`, 12], ['6 ամիս՝ ', '29 000 դրամ/ամիս', 6], ['3 ամիս՝ ', '19 000 դրամ/ամիս', 3] ],
                    cash: '',
                    id: 2,
                },
                {
                    packageHeader: 'Պրեմիում փաթեթ',
                    packageText: '',
                    packageContent: 'էկոնոմ+ ավտոմատացում` տենդերների մասնակցության հայտերի և հաղթելուց հետո ներկայացվող փաստաթղթերի ավտոմատ պատրաստման գործիքներ...',
                    buttonContent: 'Գնել',
                    changeBoolean: false,
                    sumAndMonth: [ ['12 ամիս՝ ', '69 000 դրամ/ամիս', 12], ['6 ամիս՝ ', '49 000 դրամ/ամիս', 6], ['3 ամիս՝ ', '39 000 դրամ/ամիս', 3], ['1 ամիս՝ ', '19 000 դրամ/ամիս', 1] ],
                    cash: '',
                    id: 3
                },
                {
                    freePeriod: '10 օր անվճար',
                    packageHeader: 'Գոլդ փաթեթ',
                    packageText: '',
                    packageContent: 'էկոնոմ+Պրեմիում+ կառավարում` նախահաշվային գներ, հաղթած տենդերների պահեստի ձևավորում և կառավարում, խորհրդատվություն...',
                    buttonContent: 'Գնել',
                    sumAndMonth: [ ['12 ամիս՝ ', '99 000 դրամ/ամիս', 12], ['6 ամիս՝ ', '69 000 դրամ/ամիս', 6], ['3 ամիս՝ ', '49 000 դրամ/ամիս', 3], ['1 ամիս՝ ', '29 000 դրամ/ամիս', 1] ],
                    changeBoolean: false,
                    cash: '',
                    id: 4
                }
            ],
            packageBlockContentForState: [
                {
                    packageHeader: 'Էկոնոմ փաթեթ',
                    packageText: '',
                    packageContent: 'Տենդերների տեղեկատվություն` տենդերներ /պետական, մասնավոր/, մրցակիցներ, հաղթող գներ...',
                    buttonContent: 'Գնել',
                    changeBoolean: false,
                    sum: null,
                    cash: '',
                    id: null,
                },
                {
                    packageHeader: 'Պրեմիում փաթեթ',
                    packageText: '',
                    packageContent: 'էկոնոմ+ ավտոմատացում` տենդերների մասնակցության հայտերի և հաղթելուց հետո ներկայացվող փաստաթղթերի ավտոմատ պատրաստման գործիքներ...',
                    buttonContent: 'Գնել',
                    changeBoolean: false,
                    sum: null,
                    cash: '',
                    id: null,
                },
                {
                    packageHeader: 'Գոլդ փաթեթ',
                    packageText: '',
                    packageContent: 'էկոնոմ+Պրեմիում+ կառավարում` նախահաշվային գներ, հաղթած տենդերների պահեստի ձևավորում և կառավարում, խորհրդատվություն...',
                    buttonContent: 'Գնել',
                    sum: null,
                    changeBoolean: false,
                    cash: '',
                    id: null,
                }
            ]
        }
        },
        components: {PaymentModal, PaymentStateModal},
  }
</script>


<style scoped>
    .h-0{
        transition: transform 0.2s, height 0.4s;
        height: 0;
    }
    
    .hidden {
        transform: translateX(-100%);
        transition: transform 0.5s, opacity 2s;
        opacity: 0;
    }

    .show {
        opacity: 1 !important;
        transform: translateX(0%) !important;
        height: fit-content !important;
    }

    .more{
        font-size: 18px;
        color: #3ccdac;
        font-weight: 600;
    }
    .info{
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 0;
    }
    .child-list{
        margin-left: 20px;
        margin-top: 20px;
    }
    .child-list li{
        list-style: square;
    }
    ul li{
        list-style: disc;
        color: #1c1c1c;
        font-size: 14px;
        margin-top: 10px;
    }
    .price-table{
        overflow-x: scroll;
        overflow-y: hidden !important;
        padding: 25px 0;
        width: 1600px !important;
    }
    .state-price-table{
        width: 100% !important;
        overflow-x: scroll;
        overflow-y: hidden !important;
        padding: 25px 0;
    }
    .state-price-table tr{
        width: 100%;
    }
    .state-price-table thead tr th{
        white-space: pre;
        border-bottom: 1px solid gray;
        border-right: 1px solid gray;
        border-top: 1px solid gray;
    }
    .state-price-table tbody tr td{
        padding: 30px 10px;
        border-bottom: 1px solid gray;
        border-right: 1px solid gray;
    }
    .state-price-table thead tr th{
        padding: 10px 20px;
        font-size: 18px;
    }

    .price-table tr{
        width: 100%;
    }

    .price-table thead tr th{
        white-space: pre;
        border-bottom: 1px solid gray;
        border-right: 1px solid gray;
        border-top: 1px solid gray;
    }
    .price-table tbody tr td{
        padding: 30px 10px;
        border-bottom: 1px solid gray;
        border-right: 1px solid gray;
    }
    .price-table thead tr th{
        padding: 10px 20px;
        font-size: 18px;
    }
    .plus{
        font-size: 25px;
        color: #06ad58;
    }
    .minus{
        font-size: 25px;
        color: #e42323;
    }
    .table-sp{
        margin-top: 320px;
        margin-bottom: 50px;
        overflow-x: scroll;
        overflow-y: hidden;
        padding-top: 28px !important;
        padding-bottom: 28px !important;
    }
    .details{
        font-size: 18px;
        color: #1e7bb7;
        font-weight: 600;
        width: 500px;
    }
    .package-btn{
        background: linear-gradient(180deg, #1E7BB7 0%, #43B4B2 100%);
        border-radius: 50px;
        font-weight: 400;
        font-size: 28px;
        line-height: 33px;
        text-transform: uppercase;
        color: #FFFFFF;
        padding: 6px 35px;
        border: 0;
        position: absolute;
        bottom: -1px;
        right: -10px;
    }
    .cursor{
        cursor: pointer;
    }
    .pay-btn{
        background: linear-gradient(
    180deg, #1E7BB7 0%, #43B4B2 100%);
        border-radius: 50px;
        height: 45px;
        width: 95%;
        border: 0;
        position: absolute;
        bottom: -15px;
        left: 5px;
        right: 5px;
        padding: 0 16px;

    }
    .pay-btn p{
        font-weight: 400;
        font-size: 16px;
        line-height: 28px;
        text-transform: uppercase;
        color: #FFFFFF;
        margin-bottom: 0 !important;
    }
    .blue-circle{
        width: 20px;
        height: 20px;
        margin-top: 2px;
    }
    .sum-text{
        font-weight: 400;
        font-size: 16px;
        line-height: 28px;
        color: #24323f; 
        margin-left: 12px;
        margin-right: 15px;
    }
    .new-container{
        padding: 0 8%;
    }
    .new-header-container{
        padding: 0 8%;
    }
    .w-300{
        width: 300px;
    }
    .color{
        color: #6ba4c5;
    }
    @media only screen and (max-width: 1200px){
        .state-price-table{
            width: 1300px !important;
        }   
    }
    @media only screen and (max-width: 1100px){
        .new-container{
            padding-left: 10%;
            padding-right: 10%;
        }
        .new-header-container{
            padding-left: 8%;
            padding-right: 8%;
        }
        .details{
            font-size: 14px;
        }
        .price-table thead tr th{
            font-size: 14px;
        }
    }   
    @media only screen and (max-width: 500px){
        .new-container{
            padding-left: 5%;
            padding-right: 5%;
        }
    }  
</style>